import { useOrganizationContext } from 'src/sections/@dashboard/organization/hooks/useOrganizationContext';
import { Roles } from 'src/types/User';
import { useWarehouseStockEnabled } from './useClinicalStockProducts';

/**
 * Whether a Sale can start in the selected organization: the user acts in it
 * as a member (the selected role, never a role merely held; the backend's
 * `WAREHOUSE_READ_ROLES`) and its Warehouse is enabled, since a Sale is a
 * stock write (R1). Both Sale entry points are hidden otherwise.
 */
export function useCanStartSale(): boolean {
  const {
    selectedOrganization,
    selectedRole,
    isProfessionalRoleSelected,
    isOrganizationAdminRoleSelected,
  } = useOrganizationContext();
  const stockEnabled = useWarehouseStockEnabled();
  const actsAsMember =
    Boolean(isProfessionalRoleSelected) ||
    Boolean(isOrganizationAdminRoleSelected) ||
    selectedRole === Roles.organization_owner;
  return Boolean(selectedOrganization?.id) && actsAsMember && stockEnabled;
}
